export const AdornmentType = {
  START: 'startAdornment',
  END: 'endAdornment',
};

export const AdornmentPosition = {
  START: 'start',
  END: 'end',
};

export const ADORNMENT_TYPE_TO_POSITION_MAP = {
  [AdornmentType.START]: AdornmentPosition.START,
  [AdornmentType.END]: AdornmentPosition.END,
};

// react-number-format passes the props a format does not know to the input, so NumericFormat must not get
// the pattern props and PatternFormat must not get the numeric ones.
export const NUMERIC_FORMAT_PROPS = [
  'allowLeadingZeros',
  'allowNegative',
  'allowedDecimalSeparators',
  'decimalScale',
  'decimalSeparator',
  'fixedDecimalScale',
  'prefix',
  'suffix',
  'thousandSeparator',
  'thousandsGroupStyle',
];
export const PATTERN_FORMAT_PROPS = ['allowEmptyFormatting', 'format', 'mask', 'patternChar'];
